export const CustomStockHistoryModalColumnWrapper = ({
  children,
  align = 'left'
}) => {
  const textAlignClass = {
    left: 'text-start',
    right: 'text-end',
    center: 'text-center'
  }

  const alignClass = textAlignClass[align] || 'text-start'

  return <div className={`fs-6 ${alignClass}`}>{children}</div>
}
